import { Link } from "react-router-dom";
import { SITE_NAV_SITELINKS } from "../constants/structuredData";
import { APP_LINKS } from "../constants/appStoreLinks";

/**
 * Visible site map for users and crawlers — strengthens internal linking for Google sitelinks.
 */
export default function SiteLinksNav({ variant = "light", className = "" }) {
  const isDark = variant === "dark";

  return (
    <nav
      aria-label="Tydii site pages"
      className={`border-t pt-6 ${
        isDark ? "border-sky-700/60" : "border-[#E3F8FF]"
      } ${className}`}
    >
      <h2
        className={`text-sm font-semibold text-center mb-4 ${
          isDark ? "text-white" : "text-[#023B64]"
        }`}
      >
        Explore Tydii
      </h2>
      <ul
        className={`flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm ${
          isDark ? "text-sky-100" : "text-[#50555C]"
        }`}
      >
        {SITE_NAV_SITELINKS.map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              className={
                isDark
                  ? "hover:text-white hover:underline"
                  : "hover:text-[#02537F] hover:underline"
              }
            >
              {item.name}
            </Link>
          </li>
        ))}
        <li>
          <a
            href={APP_LINKS.customer.ios}
            target="_blank"
            rel="noopener noreferrer"
            className={
              isDark
                ? "hover:text-white hover:underline"
                : "hover:text-[#02537F] hover:underline"
            }
          >
            Download on the App Store
          </a>
        </li>
        <li>
          <a
            href={APP_LINKS.customer.android}
            target="_blank"
            rel="noopener noreferrer"
            className={
              isDark
                ? "hover:text-white hover:underline"
                : "hover:text-[#02537F] hover:underline"
            }
          >
            Get it on Google Play
          </a>
        </li>
      </ul>
    </nav>
  );
}
